export default __webpack_public_path__ + "static/media/send-an-offer.8e45f5cb.mp4";